module.exports = __webpack_public_path__ + "img/logo.b5b9f252.png";